import { render, staticRenderFns } from "./ExtensionsFilter.vue?vue&type=template&id=637b85f1&scoped=true&"
import script from "./ExtensionsFilter.vue?vue&type=script&lang=ts&"
export * from "./ExtensionsFilter.vue?vue&type=script&lang=ts&"
import style0 from "./ExtensionsFilter.vue?vue&type=style&index=0&id=637b85f1&lang=scss&scoped=true&"
import style1 from "./ExtensionsFilter.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637b85f1",
  null
  
)

export default component.exports